export default __webpack_public_path__ + "static/media/maps.dfee149d.jpg";